/* EVH 2026-10-15: show only while the visitor scrolls UP, and only after they are deep in the page; hides again 3 s after the last upward scroll or when scrolling down. */
class BackToTop extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    this.isAppear = false;
    this.lastY = window.scrollY;
    this.upAccum = 0;
    this.hideTimer = null;
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    this.onButtonClickHandler = this.onButtonClick.bind(this);
    this.querySelector('button').addEventListener('click', this.onButtonClickHandler);
  }

  onScroll() {
    const y = window.scrollY;
    const dy = this.lastY - y; // > 0 = scrolling up
    this.lastY = y;
    const minDepth = Math.max(600, window.innerHeight * 1.2);
    if (y < 200) { this.upAccum = 0; if (this.isAppear) this.hide(); return; }
    if (dy > 0) {
      this.upAccum += dy;
      if (!this.isAppear && y > minDepth && this.upAccum >= 40) this.appear();
      if (this.isAppear) this.armHide();
    } else if (dy < -10) {
      this.upAccum = 0;
      if (this.isAppear) this.hide();
    }
  }

  armHide() {
    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(() => this.hide(), 3000);
  }

  onButtonClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.hide();
  }

  appear() { this.classList.add('open'); this.isAppear = true; }
  hide() { clearTimeout(this.hideTimer); this.classList.remove('open'); this.isAppear = false; this.upAccum = 0; }
}

customElements.define('back-to-top', BackToTop);
